import React from 'react';

import Feedback from '@vg/feedback';

function createMarkup(html) {
    return { __html: html };
}

// eslint-disable-next-line react/prop-types
const ActionableText = ({ text, settings }) => (
    <Feedback settings={settings}>
        {/* eslint-disable react/no-danger */}
        <div dangerouslySetInnerHTML={createMarkup(text.value)} />
    </Feedback>
);

export default ActionableText;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/ActionableText.js
 **/